export const AUTH_STORAGE_KEYS = {
  TOKEN: 'token',
  PENDING_ACCOUNT: 'pendingAccount',
} as const;

export const storeAuthToken = (token: string): void => {
  localStorage.setItem(AUTH_STORAGE_KEYS.TOKEN, token);
};

export const getAuthToken = (): string | null => {
  return localStorage.getItem(AUTH_STORAGE_KEYS.TOKEN);
};

export const removeAuthToken = (): void => {
  localStorage.removeItem(AUTH_STORAGE_KEYS.TOKEN);
};

export const isAuthenticated = (): boolean => {
  return !!getAuthToken();
};

export const storePendingAccount = (accountData: any): void => {
  localStorage.setItem(AUTH_STORAGE_KEYS.PENDING_ACCOUNT, JSON.stringify(accountData));
};

export const getPendingAccount = (): any | null => {
  const data = localStorage.getItem(AUTH_STORAGE_KEYS.PENDING_ACCOUNT);
  return data ? JSON.parse(data) : null;
};

export const updatePendingAccount = (updates: any): void => {
  const existing = getPendingAccount();
  if (existing) {
    const updated = {...existing, ...updates};
    storePendingAccount(updated);
  }
};

export const clearAuthData = (): void => {
  removeAuthToken();
  localStorage.removeItem(AUTH_STORAGE_KEYS.PENDING_ACCOUNT);
};

export const mapUserToPendingAccount = (user: any) => ({
  accountId: user.id,
  email: user.email,
  firstName: user.firstName,
  lastName: user.lastName,
  isVerified: user.isVerified,
});

export const upsertPendingAccount = (user: any): void => {
  const accountData = mapUserToPendingAccount(user);
  const existing = getPendingAccount();

  if (existing) {
    updatePendingAccount(accountData);
  } else {
    storePendingAccount(accountData);
  }
};
